export default function StepShell({ active, step, segment, children }) {
  return (
    <div className={active ? 'block animate-fade-in' : 'hidden'} data-step={step} data-segment={segment}>
      {children}
    </div>
  )
}

export function Question({ children }) {
  return <div className="text-[1.08rem] font-semibold tracking-[-0.01em]">{children}</div>
}

export function Hint({ children }) {
  return <div className="mt-1.5 text-[0.9rem] leading-[1.5] text-[var(--muted)]">{children}</div>
}

export function Summary({ children, className = '', ...props }) {
  return (
    <div
      className={`mt-1.5 rounded-[11px] border border-[var(--line)] bg-[var(--paper-2)] px-[18px] py-4 font-mono text-[13px] leading-[1.85] text-[var(--ink-2)] [&_b]:font-semibold [&_b]:text-[var(--ink)] ${className}`}
      {...props}
    >
      {children}
    </div>
  )
}
